<template>
  <div class="layout__container">
    <h3 class="text__align-center text__colour-teal">Lapsed for last 6-12 months excluding corporates</h3>
    <div class="layout__position-center">
      <div class="layout__position-left layout__width-100">
        <NoSpendSearch
          v-if="! isGettingTotal"
          :sales="sales"
          :search-params="searchParams"
        />
      </div>
      <div class="insights-table layout__width-100 layout__position-left">
        <el-table
          class="el-table__09vh"
          :data="sales"
          height="620px"
          @sort-change="handleSortOrderChange"
          v-loading.fullscreen.lock="loading || isGettingTotal"
          element-loading-text="Loading..."
          element-loading-background="rgba(79, 147, 168, 0.2)"
          empty-text="No data has been returned for the selected dates"
        >
          <el-table-column
            v-for="noSpendClient in NoSpendClients.fields()"
            :key="`${noSpendClient}.${new Date()}`"
            :prop="noSpendClient"
            :show-overflow-tooltip="true"
            :min-width="NoSpendClients.getColumnWidth(noSpendClient)"
            :label="NoSpendClients.getReadable(noSpendClient)"
            class-name="layout__width-150px el-table-column__no-pointer"
            sortable="custom"
          />
        </el-table>
      </div>

      <div
        v-if="searchParams.total"
        class="layout__padding-clear layout__width-60"
      >
        <div class="layout__padding-20-0 text__align-center">
          <el-pagination
            :current-page="searchParams.currentPage"
            :page-size="searchParams.pagination"
            layout="prev, pager, next"
            :total="searchParams.total"
            @update:currentPage="onCurrentPageUpdate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import NoSpendSearch from '@/components/insights/NoSpendSearch';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { sortJsonArrayHelper } from '@/mixins/sort-json-array.js';
import NoSpendClients from '../../../enums/NoSpendClients';
import moment from 'moment';

export default {
  name: 'NoSpendReport',

  mixins: [
    axios,
    csvDownloadHelper,
    dataFormatter,
    sortJsonArrayHelper,
  ],

  components: {
    NoSpendSearch,
  },

  props: {
    view: '',
  },

  data() {
    return {
      sales: [],
      loading: false,
      isGettingTotal: false,
      loadings: {},
      NoSpendClients: NoSpendClients,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_no_spend.csv',
      searchParams: {
        currentPage: 1,
        pagination: 40,
        total: 0,
      },
    };
  },

  async created() {
    this.isGettingTotal = true;

    this.isUserAuthorised();

    const url = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNoSpend?getCount=1&cnt=1&start=0`;

    this.searchParams.total = (await Axios.get(url, this.returnHeaderUsingToken())).data[0]?.count || 0;

    this.isGettingTotal = false;
  },

  methods: {
    formatSpends(amount) {
      return this.formatCurrencyTwoPlaces(amount ? amount : 0);
    },

    handleSortOrderChange(sortProps) {
      this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
    },

    csv(index) {
      this.$set(this.loadings, index, false);

      const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNoSpend`;

      Axios.get(endpoint, this.returnHeaderUsingToken())
        .then(response => {
          const spendFields = [
            'avgorder',
            'toolkit',
            'email',
            'bespoke',
            'instantprint',
            'photofixr',
            'myravensworth',
            'delivery',
            'net_total',
          ];

          const fields = this.NoSpendClients.createLabelValueList();

          let noSpendClients = response.data;

          noSpendClients = noSpendClients.map((noSpendClient) => {
            spendFields.forEach((field) => {
              noSpendClient[field] = this.formatSpends(noSpendClient[field]);
            });

            noSpendClient['last_order'] = noSpendClient['last_order']
              ? moment(noSpendClient['last_order']).format('DD/MM/YYYY')
              : '';

            return {
              ...noSpendClients,
            };
          });

          this.downloadCsv(this.exportDate, fields, noSpendClients);

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        });
    },

    onCurrentPageUpdate(page) {
      this.searchParams.currentPage = page;
    },
  },
};
</script>